import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";
import Task from "../../model2/task/task";

// const debug = "ExpensesModule"
const debug = false

export class EmailTemplatesModule extends ModuleProto {

    private _emailTemplates            : any[]  = []     // when true - user can submit toward tasks

    constructor(moduleConfig:JSONObject) {
        super(ModuleType.EMAIL_TEMPLATES, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=",moduleConfig)

        this.name                       = "Email Templates"
        this.description                = "This module allows creating custom email templates that can be used within the system"
        this.svgIcon                    = "isvg-email-templates"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Core"

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.settingsUrl                = "settings/email-templates"
        this.parentSection              = SettingsParentSection.SYSTEM


        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }


    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)

        const result = super.toJson();

        // if (!this.tasks) {
        //     result.tasks = this.tasks
        // }

        debug && console.log(debug, "    newConfig=", result)

        return result
    }

    goToSettings() {
        gd.goTo('settings/email-templates')
    }

}
